import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import {
  CBadge, CButton, CDropdown, CDropdownItem, CDropdownMenu, CDropdownToggle,
} from '@coreui/react';
import useGlobalSelectionsContext from '../../core/hooks/useGlobalSelectionsContext';
import { getCustomMethodsList } from '../CustomMethods/List/api.service';
import { getEvents } from '../LocationsAndEvents/Events/api.service';
import { getLocations } from '../LocationsAndEvents/Locations/api.service';
import { displayEventDate } from '../../core/helpers/date';

const propTypes = {
  onChangeFilters: PropTypes.func.isRequired,
  filters: PropTypes.shape({
    method: PropTypes.string,
    event: PropTypes.string,
    location: PropTypes.string,
    prospect_location: PropTypes.number,
  }).isRequired,
};

const ProspectsFilter = ({ onChangeFilters, filters }) => {
  const { organizationId, initiativeId } = useGlobalSelectionsContext();
  const [methods, changeMethods] = useState([]);
  const [events, changeEvents] = useState([]);
  const [locations, changeLocations] = useState([]);

  useEffect(() => {
    getCustomMethodsList({
      perPage: 999,
      initiative_id: initiativeId,
      organization_id: organizationId,
      active: 1,
    })
      .then(({ data }) => data.data.map(({ name, id }) => ({ label: name, value: id })))
      .then(changeMethods);

    getEvents({
      perPage: 999,
      initiative_id: initiativeId,
      organization_id: organizationId,
      sort: 'start_time',
    })
      .then(({ data }) => data.data.map((event) => ({
        label: displayEventDate(event),
        value: event.id,
      })))
      .then(changeEvents);

    getLocations({
      perPage: 999,
      initiative_id: initiativeId,
      organization_id: organizationId,
    })
      .then(({ data }) => data.data.map(({ name, id }) => ({ label: name, value: id })))
      .then(changeLocations);
    // eslint-disable-next-line
  }, []);

  return (
    <CDropdown className="MethodStatusFilter">
      <CDropdownToggle caret color="info">
        Filter
      </CDropdownToggle>
      <CDropdownMenu placement="bottom-end">
        {Object.keys(filters).length > 0 && (
        <div className="pr-3 pl-3">
          <CButton size="sm" className="btn-brand w-100" color="danger" onClick={() => onChangeFilters({})}>
            <span>Clear</span>
          </CButton>
        </div>
        )}
        <CDropdownItem header>By Method</CDropdownItem>
        {methods.map((item) => (
          <CDropdownItem
            key={item.value}
            onClick={() => onChangeFilters({ ...filters, method: item.value })}
          >
            {item.label}
            {item.value === filters.method && (<CBadge color="primary" className="ml-1">Active</CBadge>)}
          </CDropdownItem>
        ))}
        <CDropdownItem divider />
        <CDropdownItem header>By Locations</CDropdownItem>
        {locations.map((item) => (
          <CDropdownItem
            key={item.value}
            onClick={() => onChangeFilters({ ...filters, location: item.value })}
          >
            {item.label}
            {item.value === filters.location && (<CBadge color="primary" className="ml-1">Active</CBadge>)}
          </CDropdownItem>
        ))}
        <CDropdownItem header>By Events</CDropdownItem>
        {events.map((item) => (
          <CDropdownItem
            key={item.value}
            onClick={() => onChangeFilters({ ...filters, event: item.value })}
          >
            {item.label}
            {item.value === filters.event && (<CBadge color="primary" className="ml-1">Active</CBadge>)}
          </CDropdownItem>
        ))}
        <CDropdownItem divider />
        <CDropdownItem
          onClick={() => onChangeFilters({
            ...filters,
            prospect_location: filters.prospect_location ? undefined : 1,
          })}
        >
          Prospect Location
          {filters.prospect_location === 1 && (<CBadge color="primary" className="ml-1">Active</CBadge>)}
        </CDropdownItem>
      </CDropdownMenu>
    </CDropdown>
  );
};

ProspectsFilter.propTypes = propTypes;

export default ProspectsFilter;
